import React, { useState } from 'react';
import {useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';
import { useAuth } from '../context/AuthContext'; // Asegúrate de que este hook esté configurado correctamente
import '../styles/admincode.css'; // Archivo CSS con los estilos específicos

function AdminCodePage() {
  const { token } = useAuth();
  const [skuCode, setSkuCode] = useState('');
  const [barcode, setBarcode] = useState('');
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState('');

  const handleSubmit = async () => {
    if (!token) {
      setResponseMessage('No token available');
      return;
    }

    if (!skuCode || !barcode) {
      setResponseMessage('Por favor, completa todos los campos');
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/update-barcode/`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sku_code: skuCode,
          barcode: barcode,
        }),
      });

      if (response.ok) {
        setResponseMessage('Código de barras actualizado con éxito');
        setSkuCode('');
        setBarcode('');
      } else {
        const errorData = await response.json();
        setResponseMessage(`Error: ${errorData.message || 'No se pudo actualizar el código de barras'}`);
      }
    } catch (error) {
      setResponseMessage(`Error: ${error.message}`);
    }
  };

  return (
    <div>
                    <button className="adminproductos-back-button" onClick={() => navigate(`/init`)}>
                &#8592;
            </button>

    <div className="admin-code-container">
      <h1 className="admin-code-title">Actualizar Código de Barras</h1>
      <div className="admin-code-form">
        <label htmlFor="sku-code" className="admin-code-label">SKU Code:</label>
        <input
          id="sku-code"
          className="admin-code-input"
          type="text"
          value={skuCode}
          onChange={(e) => setSkuCode(e.target.value)}
          placeholder="Ingresa el SKU Code"
        />

        <label htmlFor="barcode" className="admin-code-label">Barcode:</label>
        <input
          id="barcode"
          className="admin-code-input"
          type="text"
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          placeholder="Ingresa el Barcode"
        />

        <button className="admin-code-button" onClick={handleSubmit}>
          Enviar
        </button>
      </div>
      {responseMessage && <p className="admin-code-message">{responseMessage}</p>}
    </div>
    </div>
  );
}

export default AdminCodePage;
